import * as Search from "./modules/search";

// Search
if (document.querySelector(".js-search")) {
    Search.init();
}
